import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Layout, Menu, Breadcrumb, Icon, Card } from 'antd';
import '../../assets/css/App.css';
import routes from '../../model/router';
import Header1 from '../public';
import BicombImg from "../../assets/images/clarityICI.jpg";

// ===============================
// 1) CLARITY-ICI Matrix (All) data object (from attached image)
//    - Preserves coordinates: rowIndex, colIndex
//    - Preserves values as shown (Months)
// ===============================
const CLARITY_ICI_ALL = {
  title: " ",
  // xAxisLabel: " ",
  // yAxisLabel: " ",
  xLabels: [
    "Smoking No",
    "P_Treat Yes",
    "Smoking Yes",
    "Patho LUSC",
    "Patho LUAD",
    "Real_World Yes",
    "ECOG ≥1",
    "Real_World No",
    "P_Treat No",
    "Patho Other",
    "IO_Type Mono",
    "ECOG <1",
    "Stage IV",
    "IO_Type Chemo",
    "Stage I~III",
    "IO_Type Other",
  ],
  rows: [
    { yLabel: "Age >65 OS", values: [null, null, null, null, null, null, null, null, null, null, null, null, 14.8, null, 18.2, null] },
    { yLabel: "Age >65 PFS", values: [null, null, null, null, null, null, 4.0, null, null, null, null, 7.5, null, null, null, null] },

    { yLabel: "Age ≤65 OS", values: [null, null, null, null, null, null, 12.0, null, null, null, null, null, 16.7, 18.0, 21.3, null] },
    { yLabel: "Age ≤65 PFS", values: [null, null, null, null, null, null, 4.1, null, null, null, null, 6.5, null, null, null, null] },

    { yLabel: "Diameter >50 OS", values: [null, null, null, null, null, null, null, null, null, null, 9.5, null, null, null, 15.8, 19.1] },
    { yLabel: "Diameter >50 PFS", values: [3.6, null, null, null, null, null, null, null, 8.8, null, null, null, null, null, null, null] },

    { yLabel: "Diameter ≤50 OS", values: [null, null, null, null, null, null, 15.6, null, null, null, null, 19.6, null, null, null, null] },
    { yLabel: "Diameter ≤50 PFS", values: [4.2, null, null, null, null, null, null, null, 9.9, null, null, null, null, null, null, null] },

    { yLabel: "ECOG ≥1 OS", values: [null, null, null, null, null, null, null, null, null, null, null, null, 15.5, null, 16.2, null] },

    { yLabel: "IO_Type Mono PFS", values: [null, null, null, null, null, null, 3.5, null, null, null, null, 6.0, null, null, null, null] },
    { yLabel: "IO_Type Other PFS", values: [null, null, null, 3.5, 6.0, null, null, null, null, null, 11.9, null, null, null, null, null] },

    { yLabel: "Line 1L OS", values: [null, null, null, null, null, null, null, null, null, null, null, null, null, 16.0, 19.9, null] },
    { yLabel: "Line 1L PFS", values: [null, null, null, null, null, null, 7.4, null, null, null, null, 11.3, null, null, null, null] },

    { yLabel: "Line ≥2L OS", values: [null, null, null, null, null, null, 8.2, null, null, null, null, null, 15.2, 13.0, 16.5, null] },
    { yLabel: "Line ≥2L PFS", values: [3.3, 3.9, null, null, null, null, 2.8, null, null, null, null, null, 4.0, null, null, null] },

    { yLabel: "NLR Low OS", values: [null, null, null, null, null, null, 7.4, null, null, null, null, 11.1, null, null, null, null] },
    { yLabel: "NLR Low PFS", values: [3.7, null, null, null, null, null, null, null, 9.1, null, null, null, null, null, null, null] },

    { yLabel: "PD_L1 Low OS", values: [null, null, null, null, null, null, null, null, null, null, null, null, 15.0, null, 17.2, null] },

    { yLabel: "P_Treat No OS", values: [null, null, null, null, null, null, null, null, null, null, null, null, 16.0, null, 19.9, null] },
    { yLabel: "P_Treat No PFS", values: [null, null, null, null, null, null, 7.4, null, null, null, null, 11.3, null, null, null, null] },

    { yLabel: "P_Treat Yes OS", values: [null, null, null, null, null, null, 8.2, null, null, null, null, null, 15.2, 12.9, 16.5, null] },
    { yLabel: "P_Treat Yes PFS", values: [3.3, 3.9, null, null, null, null, 2.8, null, null, null, null, null, 4.0, null, null, null] },

    { yLabel: "Patho LUAD OS", values: [null, null, null, null, null, null, 12.6, null, null, null, null, null, 15.9, 17.1, 17.9, null] },
    { yLabel: "Patho LUAD PFS", values: [null, null, null, null, null, null, 4.1, null, null, null, null, 7.7, null, null, null, null] },

    { yLabel: "Patho LUSC OS", values: [null, null, null, null, null, null, 9.8, null, null, null, null, null, 17.5, null, null, null] },
    { yLabel: "Patho LUSC PFS", values: [null, null, null, null, null, null, 5.2, null, null, null, null, 9.0, null, null, null, null] },

    { yLabel: "Patho Other OS", values: [null, null, null, null, null, null, null, null, null, null, null, null, 16.3, null, 18.7, null] },
    { yLabel: "Patho Other PFS", values: [null, null, null, null, null, null, null, null, null, null, null, null, 6.6, null, 11.0, null] },

    { yLabel: "Real_World Yes OS", values: [null, null, null, null, null, null, 10.0, null, null, null, null, null, 14.4, 16.7, 20.7, null] },
    { yLabel: "Real_World Yes PFS", values: [null, null, null, 7.2, 5.6, null, 4.0, null, null, 6.8, null, 8.4, null, null, null, null] },

    { yLabel: "Region EAS OS", values: [null, null, null, null, null, null, null, null, null, null, null, null, null, 19.0, 21.2, null] },
    { yLabel: "Region EAS PFS", values: [null, null, null, null, null, 7.0, null, 8.9, null, null, null, 6.0, null, null, 10.6, null] },

    { yLabel: "Sex Female OS", values: [null, null, null, null, null, null, 13.3, null, null, null, null, null, 18.9, 15.6, 18.1, null] },
    { yLabel: "Sex Male OS", values: [null, null, null, null, null, null, 11.8, null, null, null, null, null, 15.8, 17.0, 20.1, null] },
    { yLabel: "Sex Male PFS", values: [null, null, null, null, null, null, 4.4, null, null, null, null, 8.3, 6.2, null, 10.1, null] },

    { yLabel: "Smoking No OS", values: [null, null, null, null, null, null, 14.0, null, null, null, null, null, 14.6, 16.8, 21.4, null] },
    { yLabel: "Smoking Yes OS", values: [null, null, null, null, null, null, 10.7, null, null, null, null, null, 16.5, 16.0, 19.3, null] },
    { yLabel: "Smoking Yes PFS", values: [null, null, null, null, null, null, 4.3, null, null, null, null, 8.2, 6.1, null, 10.3, null] },

    { yLabel: "Stage IV OS", values: [null, null, null, null, null, null, 15.5, null, null, null, null, null, 15.8, null, null, null] },
    { yLabel: "Stage IV PFS", values: [null, null, null, null, null, null, 5.5, null, null, null, null, 8.3, null, null, null, null] },

    { yLabel: "TMB High OS", values: [null, null, null, null, null, null, 10.9, null, null, null, null, null, 18.9, 14.1, 16.0, null] },
    { yLabel: "TMB Low OS", values: [null, null, null, null, null, null, null, null, null, null, null, null, 11.4, null, 12.0, null] },
    { yLabel: "TMB Low PFS", values: [null, null, null, null, null, null, null, null, null, null, null, 4.3, null, null, 10.0, null] },
  ],
  valueMin: 2.8,
  valueMax: 21.4,
};

// ===============================
// 2) Color scale helper (blue -> white -> green)
// ===============================
const lerp = (a, b, t) => a + (b - a) * t;

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return {
    r: parseInt(h.substring(0, 2), 16),
    g: parseInt(h.substring(2, 4), 16),
    b: parseInt(h.substring(4, 6), 16),
  };
}
function rgbToHex({ r, g, b }) {
  const toHex = (x) => x.toString(16).padStart(2, "0");
  return `#${toHex(Math.round(r))}${toHex(Math.round(g))}${toHex(Math.round(b))}`;
}
function interpolateHex(c1, c2, t) {
  const a = hexToRgb(c1);
  const b = hexToRgb(c2);
  return rgbToHex({
    r: lerp(a.r, b.r, t),
    g: lerp(a.g, b.g, t),
    b: lerp(a.b, b.b, t),
  });
}
function valueToColor(v, vMin, vMax) {
  if (v === null || v === undefined) return "transparent";
  const t = Math.min(1, Math.max(0, (v - vMin) / (vMax - vMin)));
  const blue = "#08306b";
  const white = "#f7f7f7";
  const green = "#2ca25f";
  if (t <= 0.5) return interpolateHex(blue, white, t / 0.5);
  return interpolateHex(white, green, (t - 0.5) / 0.5);
}

// ===============================
// 3) Tooltip sentence builder
//    A = x-axis label text
//    B = y-axis label text
//    C = OS or PFS from y-axis label suffix
//    D = cell value (months)
// ===============================
function parseOutcomeFromY(yLabel) {
  const s = (yLabel || "").trim();
  if (s.endsWith(" OS")) return "OS";
  if (s.endsWith(" PFS")) return "PFS";
  // fallback: try to find " OS"/" PFS" anywhere near the end
  const m = s.match(/\b(OS|PFS)\b\s*$/);
  return m ? m[1] : "";
}
function removeOutcomeSuffix(yLabel) {
  return (yLabel || "").replace(/\s+(OS|PFS)\s*$/i, "").trim();
}
function buildHoverSentence({ xLabel, yLabel, value }) {
  const B = (xLabel || "").trim();
  const A = removeOutcomeSuffix(yLabel);
  const C = parseOutcomeFromY(yLabel);
  const D = value;
  return `Patient with the stage 1 variable of ${A} (level) and the stage 2 variable of ${B} (level), the corresponding median ${C} stratification is ${D} months.`;
}

// ===============================
// 4) Matrix renderer (left-aligned + smaller x-labels + cursor tooltip)
// ===============================
class ClarityMatrixGrid extends React.PureComponent {
  render() {
    const { data, hover, tooltip, onEnter, onMove, onLeave } = this.props;
    const { xLabels, rows, valueMin, valueMax} = data;

    // Layout constants
    const cellW = 55;
    const cellH = 30;
    const yLabelW = 220;

    const isHover = (ri, ci) => hover && hover.r === ri && hover.c === ci;

    const axisLabelStyle = (active) => ({
      fontWeight: active ? "bold" : "normal",
      color: active ? "#111" : "#666",
      opacity: active ? 1 : 0.85,
      transition: "all 120ms ease",
      userSelect: "none",
    });

    return (
      <div style={{ position: "relative", marginTop: 10 }}>
        {/* Tooltip near cursor */}
        {tooltip && tooltip.visible ? (
          <div
            style={{
              position: "fixed",
              left: tooltip.x + 12,
              top: tooltip.y + 12,
              maxWidth: 420,
              background: "rgba(17,17,17,0.92)",
              color: "#fff",
              padding: "8px 10px",
              borderRadius: 6,
              fontSize: 12,
              lineHeight: "16px",
              zIndex: 9999,
              pointerEvents: "none",
              boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
            }}
          >
            {tooltip.text}
          </div>
        ) : null}

        {/* Axis titles row (yAxisLabel aligned to the left edge of the color blocks) */}
        <div
  style={{
    display: "grid",
    gridTemplateColumns: `${yLabelW}px repeat(${xLabels.length}, ${cellW}px)`,
    alignItems: "end",
    marginBottom: 0,
    columnGap: 2, // ✅ 与色块网格 gap 保持一致
  }}
>
          {/* y-axis label: italic, right-aligned to the boundary where color blocks start */}
          <div
            style={{
              fontSize: 12,
              color: "#666",
              fontWeight: "bold",
              fontStyle: "italic",
              textAlign: "right",
              lineHeight: "14px",
              width: "100%",
              display: "flex",
              justifyContent: "flex-end", // 关键：右端严格贴齐色块左边界（yLabelW的右边界）
              paddingRight: 0,
              marginRight: 0,
              userSelect: "none",
            }}
          >
           {/* yAxisLabel */}
          </div>

          {/* x-axis label centered over the color-block area */}
          <div
            style={{
              gridColumn: `span ${xLabels.length}`,
              textAlign: "center",
              fontSize: 12,
              color: "#666",
              fontWeight: "bold",
              userSelect: "none",
            }}
          >
           {/* xAxisLabel */}
          </div>
        </div>

        {/* X-axis labels (smaller font) */}
        <div
  style={{
    display: "grid",
    gridTemplateColumns: `${yLabelW}px repeat(${xLabels.length}, ${cellW}px)`,
    alignItems: "end",
    marginBottom: 6,
    columnGap: 2, // ✅ 与色块网格 gap 保持一致（否则会累计错位）
  }}
>
  <div></div>

  {xLabels.map((xl, ci) => {
    const active = hover && hover.c === ci;

    return (
      <div
        key={`${xl}-${ci}`}
        style={{
          ...axisLabelStyle(active),
          width: cellW,
          height: 34,
          position: "relative",
          display: "flex",
          justifyContent: "flex-start", // ✅ 让锚点从列左侧开始
          alignItems: "flex-end",
          overflow: "visible",
        }}
      >
        {/* 可选：画一个“刻度线”，明确标记每列左边界（你要的 tick 对齐） */}
        <div
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            width: 1,
            height: 6,
            background: "#fff",
            opacity: 0.6,
          }}
        />

        {/* 标签本体：以“左下角”为旋转原点，旋转后仍对齐列左边界 */}
        <div
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            transform: "rotate(-35deg)",
            transformOrigin: "left bottom", // ✅ 核心：严格对齐到色块左侧
            fontSize: 11,
            lineHeight: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {xl}
        </div>
      </div>
    );
  })}
</div>

        {/* Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `${yLabelW}px repeat(${xLabels.length}, ${cellW}px)`,
            gridAutoRows: `${cellH}px`,
            gap: 2,
          }}
        >
          {rows.map((row, ri) => {
            const rowActive = hover && hover.r === ri;

            return (
              <React.Fragment key={row.yLabel}>
                {/* Y label */}
                <div
                  style={{
                    ...axisLabelStyle(rowActive),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    paddingRight: 10,
                    fontSize: 13,
                  }}
                >
                  {row.yLabel}
                </div>

                {/* Cells */}
                {row.values.map((v, ci) => {
                  const active = isHover(ri, ci);
                  const bg = valueToColor(v, valueMin, valueMax);
                  const isEmpty = v === null || v === undefined;

                  return (
                    <div
                      key={`${ri}-${ci}`}
                      onMouseEnter={(e) => {
                        if (isEmpty) return;
                        onEnter(e, ri, ci, {
                          xLabel: xLabels[ci],
                          yLabel: row.yLabel,
                          value: v,
                        });
                      }}
                      onMouseMove={(e) => {
                        if (isEmpty) return;
                        onMove(e);
                      }}
                      onMouseLeave={onLeave}
                      style={{
                        width: cellW,
                        height: cellH,
                        background: bg,
                        border: active ? "2px solid #111" : "1px solid #e6e6e6",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 13,
                        fontWeight: active ? "bold" : "normal",
                        color: isEmpty ? "transparent" : "#111",
                        cursor: isEmpty ? "default" : "pointer",
                        filter: active ? "brightness(1.08)" : "none",
                        transition: "all 120ms ease",
                        userSelect: "none",
                      }}
                    >
                      {isEmpty ? "" : v}
                    </div>
                  );
                })}
              </React.Fragment>
            );
          })}
        </div>


      </div>
    );
  }
}

const { Header, Content, Footer, Sider } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;

const Ajax = require('axios');

class ClarityICIEastAsian extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverCell: null, // { r, c }
      tooltip: {
        visible: false,
        x: 0,
        y: 0,
        text: "",
      },
    };
  }

  handleEnterCell = (e, r, c, meta) => {
    const text = buildHoverSentence(meta);
    this.setState({
      hoverCell: { r, c },
      tooltip: {
        visible: true,
        x: e.clientX,
        y: e.clientY,
        text,
      },
    });
  };

  handleMoveCell = (e) => {
    // lightweight cursor-follow
    const { tooltip } = this.state;
    if (!tooltip.visible) return;
    this.setState({
      tooltip: {
        ...tooltip,
        x: e.clientX,
        y: e.clientY,
      },
    });
  };

  handleLeaveCell = () => {
    this.setState({
      hoverCell: null,
      tooltip: {
        visible: false,
        x: 0,
        y: 0,
        text: "",
      },
    });
  };

  render() {
    return (
      <div>
        <Header1></Header1>
        <Content style={{ padding: '0 50px' }}>
          <Layout style={{ background: '#fff' }}>
            <Sider width={200} style={{ background: '#fff' }}>
              <Menu
                mode="inline"
                defaultSelectedKeys={['4']}
                defaultOpenKeys={['sub1']}
                style={{ height: '100%' }}
              >
                <SubMenu key="sub1" title={<span><Icon type="user" />CLARITY-ICI</span>}>
                <Menu.Item key="1"><Link to="/clarityICI">Introduction</Link></Menu.Item>
                <Menu.Item key="2"><Link to="/clarityICIAll">All Population</Link></Menu.Item>
                <Menu.Item key="3"><Link to="/clarityICIWestern">Western</Link></Menu.Item>
                <Menu.Item key="4"><Link to="/clarityICIEastAsian">East Asian</Link></Menu.Item>
                <Menu.Item key="5"><Link to="/clarityICIIntroAnn">Animation</Link></Menu.Item>
                </SubMenu>
              </Menu>
            </Sider>

            <Content style={{padding: '0 50px' }}>
              <div
                style={{
                  background: `url(${BicombImg}) no-repeat center center`,
                  height: 300,
                  width: "100%",
                  backgroundSize: "cover",
                }}
              >
                <div style={{ textAlign: "center", color: "#fff" }}>
                  <br></br><br></br><br></br>
                  <txt style={{ fontSize: 45, fontWeight: 'bold' }}>
                    Clinical Attribute–Based Risk Matrix for Prognostication in Immunotherapy-Treated NSCLC
                  </txt>
                  <br></br>
                </div>
              </div>

              <div>
                <br></br>
                <br></br>
                <txt style={{ fontSize: 23, fontWeight: 'bold',  paddingRight: 100 }}>
                  East Asian Population CLARITY-ICI Matrix
                </txt>
                <br></br>

                <div style={{ fontSize: 20}}>
                  <txt>
                    <br></br>
                    
                    {/* (2) Left-aligned with the heading above: remove extra paddingLeft here */}
                    <div style={{ marginTop: 6 }}>
                      <ClarityMatrixGrid
                        data={CLARITY_ICI_ALL}
                        hover={this.state.hoverCell}
                        tooltip={this.state.tooltip}
                        onEnter={this.handleEnterCell}
                        onMove={this.handleMoveCell}
                        onLeave={this.handleLeaveCell}
                      />
                    </div>

                    <br></br><br></br>Please cite the following study if use the information in this website:
                    <br></br><br></br>
                    <txt style={{ fontStyle: 'italic' }}>
                     Clinical Attribute–Based Risk Matrix for Prognostication in Immunotherapy-Treated Non-Small-Cell Lung Cancer: An Individual-Patient Data Analysis of 17051 Patients.
                    </txt>
                    <br></br><br></br>

            
                  </txt>
                </div>
              </div>

            </Content>
          </Layout>
        </Content>
      </div>
    );
  }
}

export default ClarityICIEastAsian;
